import { useRef, useState } from "react";
import { catchAsync, IS_SUCCESS_RESPONSE } from "src/helpers";
import UploadFile from "src/modules/Report/UploadFile";
import { uploadOABanking, uploadTSCReport } from "src/services/requests/Report";

import CustomeDialog_2 from "src/shadcn/components/custom/CustomeDialog/CustomeDialog_2";

import { Button, Tabs, TabsList, TabsTrigger } from "src/shadcn/components/ui";
import TscListMain from "./TSC_List/TscListMain";
import OaListMain from "./OA_List/OaListMain";

const ReportMain = () => {
  const [openTsc, setOpenTsc] = useState<boolean>(false);
  const [openOa, setOpenOa] = useState<boolean>(false);
  const [isLoading, setisLoading] = useState(false);
  const [tabValue, setTabValue] = useState("ts");

  const handleOAbANKINGRequest = catchAsync(
    async (postdata: any) => {
      setisLoading(true);
      return await uploadOABanking(postdata);
    },
    (result: any) => {
      if (IS_SUCCESS_RESPONSE(result)) {
        setOpenOa(!openOa);
        setisLoading(false);
      }
    },
    () => {
      setisLoading(false);
    }
  );

  const handleTscConsumptionRequest = catchAsync(
    async (postdata: any) => {
      setisLoading(true);
      return await uploadTSCReport(postdata);
    },
    (result: any) => {
      if (IS_SUCCESS_RESPONSE(result)) {
        setOpenTsc(!openTsc);
        setisLoading(false);
      }
    },
    () => {
      setisLoading(false);
    }
  );

  return (
    <div className="w-full p-2">
      <div className="w-full ">
        {tabValue === "ts" ? (
          <TscListMain>
            <div className=" px-4 w-full space-y-">
              <h1 className="text-base text-primary font-semibold">
                {tabValue === "ts" ? "TSC Meter Report" : "OA Banking Report"}
              </h1>
              <div className="flex justify-end items-center space-x-4">
                <Tabs
                  defaultValue="account"
                  className="w-[300px] "
                  value={tabValue}
                  onValueChange={(e) => setTabValue(e)}
                >
                  <TabsList className="grid w-full grid-cols-2 bg-white border border-darkGray">
                    <TabsTrigger
                      value="ts"
                      className="  data-[state=active]:bg-primary data-[state=active]:text-white "
                    >
                      TSC Meter Report
                    </TabsTrigger>
                    <TabsTrigger
                      value="oa"
                      className="  data-[state=active]:bg-primary data-[state=active]:text-white "
                    >
                      OA Banking Report
                    </TabsTrigger>
                  </TabsList>
                </Tabs>

                <Button className="" variant={"outline"} onClick={() => setOpenTsc(!openTsc)}>
                  Upload TSC Meter Report
                </Button>
                {/* <Button
                className=""
                variant={"outline"}
                onClick={() => setOpenOa(!openOa)}
              >
                Upload OA Banking Report
              </Button> */}
              </div>
            </div>
          </TscListMain>
        ) : (
          <OaListMain>
            <div className=" px-4 w-full space-y-">
              <h1 className="text-base text-primary font-semibold">
                {tabValue === "ts" ? "TSC Meter Report" : "OA Banking Report"}
              </h1>
              <div className="flex justify-end items-center space-x-4">
                <Tabs
                  defaultValue="account"
                  className="w-[300px] "
                  value={tabValue}
                  onValueChange={(e) => setTabValue(e)}
                >
                  <TabsList className="grid w-full grid-cols-2 bg-white border border-darkGray">
                    <TabsTrigger
                      value="ts"
                      className="  data-[state=active]:bg-primary data-[state=active]:text-white "
                    >
                      TSC Meter Report
                    </TabsTrigger>
                    <TabsTrigger
                      value="oa"
                      className="  data-[state=active]:bg-primary data-[state=active]:text-white "
                    >
                      OA Banking Report
                    </TabsTrigger>
                  </TabsList>
                </Tabs>

                {/* <Button
                className=""
                variant={"outline"}
                onClick={() => setOpenTsc(!openTsc)}
              >
                Upload TSC Meter Report
              </Button> */}
                <Button className="" variant={"outline"} onClick={() => setOpenOa(!openOa)}>
                  Upload OA Banking Report
                </Button>
              </div>
            </div>
          </OaListMain>
        )}
      </div>

      <CustomeDialog_2
        isOpen={openTsc}
        headerTitle={""}
        children={
          <UploadFile
            title="Upload TSC Meter Report"
            isOpen={openTsc}
            setOpen={setOpenTsc}
            handleSubmit={handleTscConsumptionRequest}
            isLoading={isLoading}
          />
        }
      />

      <CustomeDialog_2
        isOpen={openOa}
        headerTitle={""}
        children={
          <UploadFile
            title="Upload OA Banking Report"
            isOpen={openOa}
            setOpen={setOpenOa}
            handleSubmit={handleOAbANKINGRequest}
            isLoading={isLoading}
          />
        }
      />
    </div>
  );
};

export default ReportMain;
